<template>
  <div>
    <md-list class="md-triple-line md-dense">
      <md-subheader>{{title}} - {{tournaments.length}}</md-subheader>
      <md-list-item v-for="tournament in tournaments" :key="tournament.id">
        <TournamentEntry :tournament="tournament"/>
      </md-list-item>
    </md-list>
    <p></p>
  </div>
</template>

<script>
import TournamentEntry from "./tournamentEntry.vue";

export default {
  name: "TournamentList",
  props: { title: String, tournaments: Array, tournament: Object },
  components: { TournamentEntry }
};
</script>

<style lang="scss" scoped>
.md-list {
  width: 400px;
  display: inline-block;
  overflow: auto;
  vertical-align: top;
}
</style>


// WEBPACK FOOTER //
// tournamentList.vue?f63c2cca